import { useEffect, useState } from 'react';
import { getStudentSummary } from '../../api/students360';

/**
 * The student KPI counts of GET /crm/students/summary, read once when the page opens. The strip
 * they feed is an extra: a failure (a role without the route, a network blip) leaves `data` null
 * and the page simply does not draw it.
 * @returns {{ data: object|null, loading: boolean }}
 */
export function useStudentSummary() {
  const [state, setState] = useState({ data: null, loading: true });

  useEffect(() => {
    let cancelled = false;
    getStudentSummary()
      .then((data) => { if (!cancelled) setState({ data: data || null, loading: false }); })
      .catch(() => { if (!cancelled) setState({ data: null, loading: false }); });
    return () => { cancelled = true; };
  }, []);

  return state;
}

export default useStudentSummary;
